// extracted by mini-css-extract-plugin
export default {"event":"Events-event___80Rbm","icon":"Events-icon___fPkec","activity-icon":"Events-activity-icon___Qivdo","activity-text":"Events-activity-text___DnUIl"};